import type { ReactNode } from 'react'

import { ScrollArea } from '@/components/ui/scroll-area'
import { Separator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'

import type { SettingsNavGroup, SettingsNavItem } from './settings-nav-item.interface'
import { SettingsSidebar } from './settings-sidebar.molecule'

const SIDEBAR_WIDTH = 240

interface SettingsLayoutDesktopProps {
  groupList: SettingsNavGroup[]
  activeItemId: string
  onItemClick: (item: SettingsNavItem) => void
  children: ReactNode
  sidebarTitle?: string
  contentTitle?: string
  contentDescription?: string
  className?: string
}

export const SettingsLayoutDesktop = ({
  groupList,
  activeItemId,
  onItemClick,
  children,
  sidebarTitle,
  contentTitle,
  contentDescription,
  className,
}: SettingsLayoutDesktopProps): ReactNode => (
  <div
    className={cn(
      'settings-layout settings-layout--desktop flex h-full overflow-hidden',
      className
    )}
  >
    <div className="settings-layout-sidebar shrink-0 border-r" style={{ width: SIDEBAR_WIDTH }}>
      <SettingsSidebar
        title={sidebarTitle}
        groupList={groupList}
        activeItemId={activeItemId}
        onItemClick={onItemClick}
        className="h-full"
      />
    </div>

    <div className="settings-layout-main flex min-w-0 flex-1 flex-col">
      {contentTitle && (
        <>
          <header className="settings-content-header shrink-0 p-6">
            <h1 className="text-2xl font-semibold">{contentTitle}</h1>
            {contentDescription && (
              <p className="mt-1 text-muted-foreground">{contentDescription}</p>
            )}
          </header>
          <Separator />
        </>
      )}
      <ScrollArea className="settings-layout-content min-h-0 flex-1">
        <div className="p-6">{children}</div>
      </ScrollArea>
    </div>
  </div>
)
